import Swal from "sweetalert2";

export const toast = isDesktop =>
  Swal.mixin({
    toast: true,
    position: isDesktop ? "top" : "top-start",
    showConfirmButton: false,
    timer: 2000
  });
